import { provide, ref } from 'vue';
import {getApplication} from "@/app/api";

const application = ref();

const clearApplication = () => {
	application.value = null;
}

const getApplicationAndCache = async (id) => {
	const data = await getApplication(id);
	application.value = data;
	return data;
}


export const useContext = () => provide('applicationContext', {
	application: application,
	clearApplication: clearApplication,
	getApplication: getApplicationAndCache,
});

export default useContext;
